<template>
    <custom-table
        :title="$t('pages.company.module.title')"
        :subTitle="$t('pages.company.module.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        filterComponentName="CompanyModuleFilter"
        changeUrlPage
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:id="{ row: record }">
            {{ record.id }}
        </template>
        <template v-slot:code="{ row: record }">
            {{ record.module.code }}
        </template>
        <template v-slot:name="{ row: record }">
            {{ record.module.name }}
        </template>
        <template v-slot:status="{ row: record }">
            <span :class="getModuleStatusDetail(record.status_id).badge_class"
                  class="badge">{{ getModuleStatusDetail(record.status_id).name }}</span>
        </template>
        <template v-slot:usage_start_date="{ row: record }">
            {{ (record.usage_start_date) ? $moment(record.usage_start_date).format("DD.MM.YYYY - HH:mm:ss") : '-' }}
        </template>
        <template v-slot:usage_end_date="{ row: record }">
            {{ (record.usage_end_date) ? $moment(record.usage_end_date).format("DD.MM.YYYY - HH:mm:ss") : '-' }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <a @click="fetchModule(record)"
                       class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                         </span>
                    </a>
                </el-tooltip>
                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_add_module" ref="addModuleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_add_customer_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal"
                         class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="userForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7 row" id="kt_modal_add_customer_scroll" data-kt-scroll="true"
                             data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                             data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">

                            <div class="fv-row mb-1" v-if="form.updateStatus !== true">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.module.cols.name') }}</label>
                                <el-form-item prop="labels">
                                    <el-select v-model="form.data.module_id" class="w-100"
                                               :placeholder="$t('common.chooseSelect')" filterable>
                                        <el-option-group
                                            v-for="(moduleKind, moduleKindIndex) in availableModules"
                                            :key="moduleKindIndex"
                                            :label="moduleKind.name"
                                        >
                                            <el-option
                                                v-for="(module, moduleIndex) in moduleKind.modules"
                                                :key="moduleIndex"
                                                :label="module.name"
                                                :value="module.id"
                                            />
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{
                                        $t('pages.company.module.cols.usage_start_date')
                                    }}</label>
                                <el-form-item prop="birth_date">
                                    <el-date-picker v-model="form.data.usage_start_date" type="datetime"
                                                    :placeholder="$t('common.chooseDate')"
                                                    valueFormat="YYYY-MM-DD hh:mm:ss"
                                                    :disabledDate="startDateDisabled"></el-date-picker>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{
                                        $t('pages.company.module.cols.usage_end_date')
                                    }}</label>
                                <el-form-item prop="birth_date">
                                    <el-date-picker v-model="form.data.usage_end_date" type="datetime"
                                                    :placeholder="$t('common.chooseDate')"
                                                    valueFormat="YYYY-MM-DD hh:mm:ss"
                                                    :disabledDate="endDateDisabled"></el-date-picker>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.module.cols.grace_period_days') }}</label>
                                <el-form-item>
                                    <el-input v-model="form.data.grace_period_days" type="number"/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.module.cols.status') }}</label>
                                <el-form-item prop="status">
                                    <el-radio-group v-model="form.data.status_id">
                                        <el-radio-button :label="1">{{ $t("common.active") }}</el-radio-button>
                                        <el-radio-button :label="2">{{ $t("common.passive") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary"
                                type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    props: ['companyID', 'showUserBackButton'],
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.company.module.cols.id"),
                    key: "id",
                },
                {
                    name: this.$t("pages.company.module.cols.code"),
                    scopedSlots: {customRender: "code"},
                },
                {
                    name: this.$t("pages.company.module.cols.name"),
                    scopedSlots: {customRender: "name"}
                },
                {
                    name: this.$t("pages.company.module.cols.status"),
                    scopedSlots: {customRender: "status"},
                },
                {
                    name: this.$t("pages.company.module.cols.usage_start_date"),
                    scopedSlots: {customRender: "usage_start_date"},
                },
                {
                    name: this.$t("pages.company.module.cols.usage_end_date"),
                    scopedSlots: {customRender: "usage_end_date"},
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            availableModules: [],
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    computed: {
        table() {
            return this.$store.state.module.assignment.table || [];
        },
        modules() {
            return this.$store.state.module.table || [];
        },
        saveData() {
            return this.$store.state.module.assignment.save.data;
        }
    },
    mounted() {
        this.filterParameters = {
            sort: 'created_at:desc',
            assignable_type: "COMPANY",
            assignable_id: this.companyID
        };

        this.$store.dispatch('module/assignment/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
        });

        this.$store.dispatch('module/get', {
            page: {
                pageSize: 9999
            }
        });

        this.resetForm();
    },
    methods: {
        getModuleStatusDetail(status_id) {
            return {
                1: {
                    badge_class: "badge-light-success",
                    name: this.$t("common.active")
                },
                2: {
                    badge_class: "badge-light-danger",
                    name: this.$t("common.passive")
                },
                3: {
                    badge_class: "badge-light-warning",
                    name: this.$t("common.licenceExpired")
                }
            }[status_id]
        },
        getAvailableModules() {
            const modules = this.modules.data;
            const companyModules = (this.table.data).map(item => item.module_id);

            this.availableModules = modules.map(kind => {
                return {
                    ...kind,
                    modules: kind.modules.filter(
                        module => !companyModules.includes(module.id)
                    )
                }
            }).filter(group => group.modules.length > 0)
        },
        startDateDisabled(date) {
            return date.getTime() < Date.now()
        },
        endDateDisabled(date) {
            return (date.getTime() < Date.now()) || (date.getTime() < new Date(this.form.data.usage_start_date).getTime())
        },
        refreshTable() {
            this.filterParameters = {
                sort: 'created_at:desc'
            };

            this.$store.dispatch('module/assignment/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
            });
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("module/assignment/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "new":
                    this.resetForm();
                    this.form.title = this.$t("pages.company.module.newModule");
                    this.form.data.assignable_id = this.companyID;
                    this.getAvailableModules();
                    this.showModal(this.$refs.addModuleModal);
                    break;

                case "refresh":
                    this.refreshTable();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
                user_id: this.companyID
            }, filterData);

            this.$store.dispatch("company/customer/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        onSubmit() {
            this.$refs.userForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.$store.dispatch('module/assignment/update', {
                            id: this.form.data.id,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.hideModal(this.$refs.addModuleModal);
                                    this.refreshTable();
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('module/assignment/add', {
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.hideModal(this.$refs.addModuleModal);
                                    this.refreshTable();
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        fetchModule(record) {
            this.resetForm();
            this.form.updateStatus = true;
            this.form.currentForm = 'userForm';
            this.form.title = record.module.name;

            this.$store.dispatch('module/assignment/show', {
                id: record.id,
            }).then(() => {
                let data = this.saveData;
                data.usage_start_date = data.usage_start_date ? this.$moment(data.usage_start_date).format('YYYY-MM-DD HH:mm:ss') : undefined;
                data.usage_end_date = data.usage_end_date ? this.$moment(data.usage_end_date).format('YYYY-MM-DD HH:mm:ss') : undefined;

                this.form = {...this.form, data: data, loading: false}

                this.showModal(this.$refs.addModuleModal);
            });
        },
        resetForm() {
            this.form = {
                updateStatus: false,
                data: {
                    assignable_type: "COMPANY",
                    assignable_id: undefined,
                    module_id: undefined,
                    status_id: 1,
                    usage_start_date: null,
                    usage_end_date: null,
                    grace_period_days: null,
                }
            };
        }
    },
    watch: {
        'form.data.usage_start_date'(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (new Date(this.form.data.usage_start_date).getTime() >= new Date(this.form.data.usage_end_date).getTime()) {
                    this.form.data.usage_end_date = null;
                }
            }
        }
    }
}
</script>

<style>
.order-page-header:after {
    content: "";
    clear: both;
    display: table;
}
</style>